import { MutationCache, QueryClient } from '@tanstack/react-query';

/**
 * QueryClient de la app. Toda mutación exitosa refresca las queries activas: la tabla que el
 * usuario está mirando se actualiza sola después de CUALQUIER acción (sincronizar, parar, borrar,
 * aprobar...), sin depender de que cada pantalla se acuerde de invalidar sus propias keys (el bug
 * de "hay que recargar la página"). Los `invalidateEntity` puntuales de cada pantalla siguen
 * sirviendo para marcar vistas inactivas; esto es la red de seguridad general. El resto de los
 * cambios (procesos en background, otras pestañas/usuarios) llega por WebSocket
 * (`useDeploysLiveSync`, canal `entities`).
 */
export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: () => {
        void client.invalidateQueries();
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
        gcTime: 5 * 60 * 1000, // 5 minutes
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
  return client;
}
